var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.58,173.44A1023.22,1023.22,0,0,0,49.66,365.1c8.71,26.06,19.13,51.39,29.06,77,1.31,3.38,3.29,6.77,6.55,8.36,3.76,1.84,8.35.82,12-1.25,8-4.55,15-11.93,20.53-19.2,11.44-15,16.23-33.75,20.55-51.82C151.1,324.67,174.41,274,202.8,227c22.13-36.6,47.72-72,77.91-102.44,27.09-27.3,63.09-52.8,103.62-47.77,40,5,74.17,36.18,82.7,75.36,3.84,17.67,30.94,10.19,27.1-7.47-8.42-38.66-36.9-70.82-73-86.36-38.89-16.75-80.9-11-116.59,10.91-33.55,20.56-60.74,50.08-83.86,81.58-24.77,33.76-47.72,68.61-66.52,106.1q-7.58,15.09-14.34,30.57c-11.2,25.65-21.36,51.86-28.8,78.87-2.87,10.41-4.65,21.14-8.16,31.37a67.41,67.41,0,0,1-7,14.83c-1.19,1.84-8.58,12.79-11,12.12q9.39,2.61,18.84,4.93C92.31,399.33,80,369.66,70.23,338.73A976,976,0,0,1,45.34,242.8q-7.08-34.45-11.65-69.36c-1-7.59-5.75-14-14.06-14.06C12.8,159.31,4.6,165.91,5.58,173.44Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.572970af6c5688e21f0d9d43c4a0e508.svg";
export { ForwardRef as ReactComponent };